var React = require('react');

function Repeat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 8.00001C1 9.6195 1.56153 11.1889 2.58893 12.4408C3.61632 13.6926 5.046 14.5496 6.63437 14.8655C8.22274 15.1815 9.87152 14.9369 11.2998 14.1735C12.728 13.41 13.8474 12.175 14.4672 10.6788C15.0869 9.18259 15.1687 7.51777 14.6986 5.96802C14.2285 4.41827 13.2355 3.07946 11.889 2.17972C10.5424 1.27999 8.92557 0.874981 7.31388 1.03372C5.70219 1.19245 4.1954 1.90511 3.05025 3.05026L1 1V6H6L4.11091 4.11092C5.10622 3.11562 6.48122 2.50001 8 2.50001C11.0376 2.50001 13.5 4.96244 13.5 8.00001C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8.00001L1 8.00001Z","fill":"currentColor"}));
}

Repeat.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Repeat;

Repeat.default = Repeat;
